import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { Authorizations } from 'src/app/interfaces/auth.interfaces';
import { Location } from '@angular/common';

/**
 * Guard de ruta que valida los permisos del perfil sobre una sección concreta.
 *
 * A partir de los datos de la ruta (módulo, menú y opción) consulta al
 * {@link AuthService} si el perfil del usuario tiene autorización. Cuando no la
 * tiene, redirige al listado de buques (`/ship-list`).
 */
@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {

  constructor(
		private router: Router,
    private location: Location,
		private authService: AuthService,
    // private localStorageService: LocalStorageService
	) {}

  /**
   * Determina si el perfil tiene autorización para activar la ruta solicitada.
   * @param route - Snapshot de la ruta activada; en `data['path']` contiene la tripleta módulo, menú y opción a validar.
   * @param state - Snapshot del estado del router en el momento de la navegación.
   * @returns `true` si el perfil tiene autorización; `false` si no la tiene (y redirige a `/ship-list`).
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authorization = this.authService.hasAuthorization(route.data['path'][0], route.data['path'][1], route.data['path'][2]);
    if (authorization === false) {
      this.router.navigate(['/ship-list']);
      return false;
    }
    return true;
  }
}
